import { render, staticRenderFns } from "./Level4Search.vue?vue&type=template&id=6d056a85&"
import script from "./Level4Search.vue?vue&type=script&lang=js&"
export * from "./Level4Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports